import { render } from "./Teams.vue?vue&type=template&id=1eab589e&scoped=true"
import script from "./Teams.vue?vue&type=script&lang=js"
export * from "./Teams.vue?vue&type=script&lang=js"

import "./Teams.vue?vue&type=style&index=0&id=1eab589e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eab589e"]])

export default __exports__